import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import mem from "@/view/mem";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/4380182/",
  routes: [
    {
      path: "/",
      // name: "mem",
      component: mem,
      // redirect: "/mem",
      meta: {
        title: "20元小福券7折优惠"
      }
    },
    {
      path: "/mem",
      name: "mem",
      component: mem,
      meta: {
        title: "20元小福券7折优惠"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js